var map = {
	"./blackjack.webp": 76600,
	"./cases.webp": 4613,
	"./crash.webp": 49135,
	"./duels.webp": 67439,
	"./mines.webp": 76516,
	"./placeholder.webp": 67869,
	"./roll.webp": 83575,
	"./towers.webp": 17242,
	"./upgrader.webp": 83418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51831;